export const getElectronZoomCompensationStyle = (zoomFactor: number): React.CSSProperties => {
  if (!zoomFactor || Number.isNaN(zoomFactor) || zoomFactor <= 1.001) {
    return {}
  }

  return {
    zoom: 1 / zoomFactor,
  }
}
